import authSlice from "./slices/authSlice";
import productSlice from "./slices/productSlice";

import { combineReducers } from "@reduxjs/toolkit";

export const reducers = combineReducers({
  authSlice,
  productSlice,
});
